import {
  DRAWER_LARGE_WIDTH,
  DRAWER_MEDIUM_WIDTH,
  DRAWER_SMALL_WIDTH,
  DRAWER_WIDTH,
} from 'constants/ui';

export const DrawerSize = {
  STANDARD: DRAWER_WIDTH,
  LARGE: DRAWER_LARGE_WIDTH,
  MEDIUM: DRAWER_MEDIUM_WIDTH,
  SMALL: DRAWER_SMALL_WIDTH,
};

export const DEFAULT_CANCEL_LABEL = 'Cancel';
